import { atom } from "recoil";

const DestinationPageAtom = atom<any>({
    default: null,
    key: 'destinationPageAtomKey'
})

export default DestinationPageAtom;